import { StatusBadge } from '@/components/common/StatusBadge';
import { MENU_LABEL_STATUS_BADGE, type MenuLabelStatus } from '../constants/menuLabels.constants';

interface MenuLabelStatusBadgeProps {
  status: MenuLabelStatus;
}

export function MenuLabelStatusBadge({ status }: MenuLabelStatusBadgeProps) {
  const { label, tone } = MENU_LABEL_STATUS_BADGE[status];
  return <StatusBadge tone={tone}>{label}</StatusBadge>;
}
